import FormBlock from '../../../components/Form/FormBlock';
import i18n from '../../../i18n';

/**
 * Checkout page - renders the order/checkout form using FormBlock.
 * Uses /rest/order/checkout/ which creates order from cart and collects customer details.
 * For add_store-style flow, use /rest/order/current/add_store/ when that endpoint exists.
 */
const CheckoutPage = ({ formUrl = '/rest/order/checkout/' }) => {
    return (
        <div className="col-12">
            <FormBlock url={formUrl} className="checkout-form" />
        </div>
    );
};

export default CheckoutPage;
